// import React from 'react';
// import logo from '../assets/rem-logo.png';
// import fingerImage from '../assets/fingerLady.webp'; // Add your finger image path
// import androidapp from "../assets/play-store-logo.webp"
// import ios from '../assets/OIP.jpeg'


// const AndroidApp = () => {
//     return (
//         <div className="container 2xl:px-20 mx-auto my-5">
//             <div className="bg-gradient-to-r from-purple-800 to-purple-950 flex flex-col lg:flex-row justify-between items-center p-8 rounded-2xl">
//                 {/* Left side with buttons */}
//                 <div className="flex flex-col lg:w-1/3 space-y-4 mb-8 lg:mb-0">
//                     {/* <button className=" text-white py-2 px-2 rounded-lg w-60">

//                     <a href="../assets/powergeniceng.apk" download="powergeniceng.apk">
//                     <img src={androidapp} alt="Finger pointing" className="w-full max-w-xs lg:max-w-sm" />
//                     </a>

//                     </button>
//                     <button className=" text-white py-2 px-2 rounded-lg w-60">

//                     <a href="../assets/powergeniceng.apk" download="powergeniceng.apk">
//                     <img src={ios} alt="Finger pointing" className="w-full max-w-xs lg:max-w-sm" />
//                     </a>

//                     </button> */}
//                     <button className='bg-white w-40 h-10 rounded-lg ml-24'>
//                         <a href="../assets/powergeniceng.apk">Dowload The APP</a>
//                     </button>
//                     <p className='text-xl text-white font-bold pl-24'>
//                         Powergenic Engineering
//                     </p>
//                 </div>
                
//                 {/* Right side with image and finger indicator */}
//                 <div className="hidden lg:block lg:w-2/3 flex justify-center items-center h-140 rounded-full">
//                     <img src={fingerImage}  alt="Finger pointing" className=" w-full max-w-xs lg:max-w-sm rounded-3xl" />
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default AndroidApp;





import React from "react";
import fingerImage from "../assets/fingerLady.webp"; // Finger pointing image
import androidapp from "../assets/play-store-logo.webp";
import ios from "../assets/OIP.jpeg";

const AndroidApp = () => {
  return (
    <div className="container mx-auto px-5 my-10 ">
      <div className="bg-gradient-to-r from-purple-700 to-purple-900 flex flex-col lg:flex-row items-center justify-between p-10 rounded-3xl shadow-lg">
        {/* Left Section */}
        <div className="text-center lg:text-left lg:w-1/2 space-y-4 lg:pl-20">
          <h2 className="text-3xl font-bold text-white">
            Get the <span className="text-yellow-300">Powergenic Engineering</span> App
          </h2>
          <p className="text-gray-200 text-lg">
            Download the app now to explore our latest engineering solutions and services.
          </p>

          {/* Download Buttons */}
          <div className="flex flex-col sm:flex-row justify-center lg:justify-start space-y-3 sm:space-y-0 sm:space-x-4">
            <a
              href="../assets/powergeniceng.apk"
              download="powergeniceng.apk"
              className="flex items-center bg-white text-gray-800 px-5 py-2 rounded-lg shadow-md hover:bg-gray-100 transition duration-300"
            >
              <img src={androidapp} alt="Android App" className="w-6 h-6 mr-2" href="../assets/powergeniceng.apk" download="powergeniceng.apk" />
              <span className="font-semibold">Download for Android</span>
            </a>

            <a
              href="../assets/powergeniceng.apk"
              className="flex items-center bg-white text-gray-800 px-5 py-2 rounded-lg shadow-md hover:bg-gray-100 transition duration-300"
            >
              <img src={ios} alt="iOS App" className="w-6 h-6 mr-2" />
              <span className="font-semibold">Download for iOS</span>
            </a>
          </div>
        </div>

        {/* Right Section (Image) */}
        <div className="hidden lg:block mt-6 lg:mt-0 lg:w-1/2 flex justify-center lg:pl-36">
          <img
            src={fingerImage}
            alt="Finger pointing"
            className="w-64 lg:w-80 rounded-xl shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default AndroidApp;
